import { service, base } from './app.service';
import { EServiceType } from "@/models/interfaces/Orders/EServiceType";
import { cloneDeep, forEach, filter, concat } from 'lodash';
import masterStore from '@/stores/index';
import { CART, ACCOUNT_CHECKOUT } from '@/stores/defs';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
import { v4 } from 'uuid';
var postOrder = function (base) { return "/admin/squib_order_for_pickup?b=" + base + "&origin=" + 5 + "&d=895FCDB7-301A-4321-B91C-B48DF9D44343&"; };
export var EPreorder;
(function (EPreorder) {
    EPreorder[EPreorder["PAY_NOW"] = 1] = "PAY_NOW";
    EPreorder[EPreorder["PAY_LATER"] = 2] = "PAY_LATER";
})(EPreorder || (EPreorder = {}));
var orderService = {
    getOrders: function (callback) { },
    // TODO these methods use the exported version of an item
    checkForCouponInItem: function (items) {
        var coupon = masterStore.getters[CART.GET_COUPON];
        if (!coupon) {
            return items;
        }
        forEach(items, function (item) {
            if (item.discounts.length > 0) {
                var discounts = item.discounts;
                forEach(discounts, function (discount) {
                    if (discount.discount_id === coupon.discount_id) {
                        discount.coupon_code = coupon.codeName;
                    }
                });
            }
        });
        return items;
    },
    splitItemsWithDiscount: function (items) {
        var splitItems = [];
        forEach(items, function (item) {
            item['marked'] = false;
            if (item.bundle) {
                return;
            }
            var hasDiscount = item.discounts && (item.discounts.length > 0);
            var discountLength = (hasDiscount) ? item.discounts.length : 0;
            var multipleDiscount = (discountLength >= 1);
            if (item.quantity > 1 && multipleDiscount) {
                var quantity = item.quantity;
                for (var i = 0; i < quantity; i++) {
                    var itemClone = cloneDeep(item);
                    itemClone.quantity = 1;
                    var discounts = [];
                    if (item.discounts.length > 0) {
                        discounts.push(item.discounts.pop());
                    }
                    itemClone.discounts = discounts;
                    splitItems.push(itemClone);
                }
                item['marked'] = true;
            }
        });
        var remainingItems = filter(items, function (item) {
            return item['marked'] === false;
        });
        remainingItems = concat(remainingItems, splitItems);
        forEach(remainingItems, function (item) {
            delete item['marked'];
        });
        return remainingItems;
    },
    removeDuplicatedDiscounts: function (items) {
        var usedDiscounts = {};
        var nonBundleItems = filter(items, function (item) {
            return !item.bundle;
        });
        forEach(nonBundleItems, function (item) {
            if (item.discounts.length > 0) {
                var discounts = item.discounts;
                forEach(discounts, function (discount) {
                    var discountId = discount.discount_id;
                    var redemptions = discount.maxRedemptions;
                    var limited = (redemptions !== 0);
                    var discountUsed = usedDiscounts[discountId] >= redemptions;
                    if (discountUsed && limited) {
                        discount['removal_flag'] = true;
                    }
                    if (!usedDiscounts[discountId]) {
                        usedDiscounts[discountId] = 0;
                    }
                    if (discountId && !discountUsed) {
                        usedDiscounts[discountId] += 1;
                    }
                });
                var filteredDiscounts = filter(discounts, function (discount) {
                    return !discount.removal_flag;
                });
                item.discounts = filteredDiscounts;
            }
        });
        var splitItems = this.splitItemsWithDiscount(items);
        return splitItems;
    },
    prepareOrder: function (items, lb) {
        if (lb === void 0) { lb = base; }
        var orderItems = [];
        items.forEach(function (cartItem) {
            var item = cloneDeep(cartItem);
            var exportItem = item.prepareItemForExport(lb);
            orderItems.push(exportItem);
        });
        // TODO checkForCouponInItem and removeDuplicatedDiscounts methods
        // are mutating the state of the cart it would be better to have
        // these in the cart store
        orderItems = orderService.checkForCouponInItem(orderItems);
        orderItems = orderService.removeDuplicatedDiscounts(orderItems);
        var data = JSON.stringify(orderItems);
        var form = new FormData();
        form.append('i', data);
        return form;
    },
    sendOrder: function (order) {
        var formData = orderService.prepareOrder(order.items, order.lb);
        var config = {
            withCredentials: true,
        };
        var postEndpoint = postOrder(order.lb);
        var addParameter = function (params) {
            var paramafiedStr = params;
            var keys = Object.keys(params);
            paramafiedStr = keys.reduce(function (accum, newVal) {
                if (typeof params[newVal] === 'undefined') {
                    params[newVal] = '';
                }
                return accum + ("&" + newVal + "=" + params[newVal]);
            }, "");
            postEndpoint = "" + postEndpoint + paramafiedStr;
        };
        var idempotent = localStorageAdapter.getIdempotency();
        if (!idempotent) {
            localStorageAdapter.setIdempotency(v4());
        }
        addParameter({
            idempotent: localStorageAdapter.getIdempotency(),
        });
        addParameter({
            t: order.serviceType,
        });
        if (order.delay) {
            addParameter({ pd: order.delay.pd, pdt: order.delay.pdt });
        }
        if (order.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
            if (order.deliveryAddress) {
                addParameter({ aid: order.deliveryAddress.id });
            }
            else {
                //TODO: return promise
            }
        }
        if (order.preorder === EPreorder.PAY_LATER) {
            addParameter({ preorder: order.preorder });
        }
        else if (order.a) {
            addParameter({ a: order.a });
        }
        if (order.proposed) {
            addParameter({ proposed: order.proposed });
        }
        if (masterStore.getters[ACCOUNT_CHECKOUT.GET_LEAVE_AT_DOOR]) {
            if (order.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
                order.userInstructions = "*** Leave at doorstep *** \n" + order.userInstructions;
            }
            if (order.serviceType === EServiceType.SERVICE_TYPE_TAKEOUT) {
                order.userInstructions = "*** Curbside pickup *** \n" + order.userInstructions;
            }
        }
        addParameter({
            instructions: order.userInstructions,
        });
        addParameter({
            dis: order.dis,
        });
        addParameter({
            g: order.g,
        });
        addParameter({
            customer: order.customer,
        });
        addParameter({
            m: order.m,
        });
        return service.post(postEndpoint, formData, config).then(function (response) {
            if ('idempotentToken' in response.data && response.data.idempotentToken) {
                var idempotentToken = localStorageAdapter.getIdempotency();
                if (response.data.idempotentToken !== localStorageAdapter.getIdempotency()) {
                    console.error('Token sent does not match token received, still going to clear the local token');
                    console.error('Sent: ', idempotentToken, 'Received:', response.data.idempotentToken);
                }
                localStorageAdapter.setIdempotency(null);
            }
            return response;
        }).catch(function (error) {
            return error;
        });
    },
    emailOrderReceipt: function (orderId, locationBase, email) {
        var url = "/admin/squib_email_receipt?e=" + email + "&o=" + orderId + "&l=" + locationBase;
        return service.post(url, null, { withCredentials: true });
    },
    smsOrderReceipt: function (orderId, lb) {
        var url = "/admin/squib_sms_receipt?b=" + lb + "&o=" + orderId;
        return service.get(url);
    },
    getOrder: function (orderId, locationBase) {
        var url = "/admin/squib_get_online_order?o=" + orderId + "&b=" + locationBase + "&add_sibs=1&add_api_format=1&add_excluded_choices=1";
        return service.get(url);
    },
    getGuestOrder: function (orderId, locationBase, userBase) {
        var url = "/admin/squib_get_online_order?o=" + orderId + "&b=" + locationBase + "&user_base=" + userBase + "&add_sibs=1&add_api_format=1&add_excluded_choices=1";
        return service.get(url);
    },
};
export default orderService;



//////////////////
// WEBPACK FOOTER
// ./src/services/order.service.ts
// module id = yEUW
// module chunks = 18